import React from 'react';
import { ReportType } from '@/pages/reports/ReportsPage/types';

const typeStyles: Record<ReportType, string> = {
  medical: 'bg-red-100 text-red-800 ring-red-200 dark:bg-red-900/40 dark:text-red-300 dark:ring-red-800',
  training: 'bg-amber-100 text-amber-800 ring-amber-200 dark:bg-amber-900/40 dark:text-amber-300 dark:ring-amber-800',
  scouting: 'bg-blue-100 text-blue-800 ring-blue-200 dark:bg-blue-900/40 dark:text-blue-300 dark:ring-blue-800',
  performance: 'bg-violet-100 text-violet-800 ring-violet-200 dark:bg-violet-900/40 dark:text-violet-300 dark:ring-violet-800',
};

const typeLabels: Record<ReportType, string> = {
  medical: 'Medical',
  training: 'Training',
  scouting: 'Scouting',
  performance: 'Performance',
};

const ReportTypeBadge: React.FC<{ type: ReportType }> = ({ type }) => (
  <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ring-inset ${typeStyles[type]}`}>
    {typeLabels[type]}
  </span>
);

export default ReportTypeBadge;
